import React from 'react';
import { LogOut, Printer } from 'lucide-react';
import { Button } from '../ui/button';
import { vibeStyle } from '../../utils/vibeStyle';

const StoryCard = ({ draft, alias, onDone }) => {
  const story = draft.story || {};
  const { Icon, color } = vibeStyle(story.vibe || draft.vibe);
  const words = story.words || [];

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center pb-10">
      <div
        className="story-card relative overflow-hidden rounded-[2rem] border bg-[#0D1012]
          p-6 shadow-2xl sm:p-10"
        style={{ '--story-color': color, borderColor: `${color}80` }}
      >
        <div className="story-card-glow" />
        <div className="relative z-10">
          <div className="flex items-center justify-between gap-4">
            <p className="font-heading text-sm font-black tracking-[0.2em] text-white/60">STUDIO PLAYGROUND</p>
            <span
              className="flex h-14 w-14 items-center justify-center rounded-2xl border"
              style={{ color, borderColor: `${color}66`, backgroundColor: `${color}15` }}
            >
              <Icon className="h-7 w-7" />
            </span>
          </div>
          <div className="py-12 sm:py-16">
            <p
              className="mb-3 text-base font-extrabold uppercase tracking-[0.16em]"
              style={{ color }}
            >
              A story by {alias}
            </p>
            <h1 className="font-heading text-4xl font-black leading-tight sm:text-6xl">{story.title || draft.title}</h1>
            <div className="mt-6 flex flex-wrap gap-2">
              {words.slice(0, 3).map((word) => (
                <span
                  key={word}
                  className="rounded-full border px-4 py-2 text-base font-black"
                  style={{ color, borderColor: `${color}70`, backgroundColor: `${color}10` }}
                >
                  {word}
                </span>
              ))}
            </div>
            <p
              className="mt-9 max-w-2xl font-heading text-2xl font-bold leading-relaxed
                text-white/85 sm:text-3xl"
            >
              {story.message}
            </p>
          </div>
          <div className="flex items-end justify-between gap-5 border-t border-white/10 pt-5">
            <p className="text-base font-bold text-white/55">Your words. Your voice. Your song.</p>
            <div className="h-2 w-20 rounded-full" style={{ backgroundColor: color, boxShadow: `0 0 18px ${color}` }} />
          </div>
        </div>
      </div>

      <div className="mt-6 grid gap-3 print:hidden sm:grid-cols-2">
        <Button
          type="button"
          variant="outline"
          onClick={() => window.print()}
          className="min-h-12 rounded-full border-white/20 text-base font-black hover:bg-white/10"
        >
          <Printer className="h-5 w-5" /> Print
        </Button>
        <Button
          type="button"
          onClick={onDone}
          className="min-h-12 rounded-full bg-cyan text-base font-black text-black hover:bg-cyan/90"
        >
          <LogOut className="h-5 w-5" /> Done
        </Button>
      </div>
    </div>
  );
};

export default StoryCard;
